module.exports = __webpack_public_path__ + "img/frame (111).2bb9c896.jpg";